<!-- Hero Section (Consistent with other pages) -->
<div class="annual-hero-bg">
    <section class="annual-hero-section container">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6 hero-content-col">
                    <h1 class="banner-heading-one">Join Our Team</h1>
                    <p class="hero-subtext">Explore opportunities to grow, innovate, and make an impact with Kalpita.
                    </p>
                    <nav aria-label="breadcrumb" class="breadcrumb-nav">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <a (click)="nav('/')">Home</a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Careers</li>
                        </ol>
                    </nav>
                </div>
                <div class="col-lg-6 hero-video-col text-center">
                    <video #heroVideo preload="auto" src="../../../../assets/careers/openpositions-video.webm"
                        class="hero-video" autoplay loop muted playsinline disablePictureInPicture>
                    </video>
                </div>
            </div>
        </div>
    </section>
</div>

<!-- Ratings Section -->
<div class="ratings-section">
    <div class="container">
        <div class="ratings-grid">
            <a href="https://www.ambitionbox.com/reviews/kalpita-technologies-reviews" target="_blank"
                class="rating-card" data-aos="fade-up" data-aos-delay="100">
                <img src="../../../assets/common/footer-icons/ambitionbox-FooterRatings.png" alt="AmbitionBox">
            </a>
            <a href="https://www.glassdoor.co.in/Reviews/Kalpita-Technologies-Reviews-E3039050.htm" target="_blank"
                class="rating-card" data-aos="fade-up" data-aos-delay="200">
                <img src="../../../assets/common/footer-icons/glassdoor-FooterRatings.png" alt="Glassdoor">
            </a>
            <a href="https://g.page/r/CamDBGN8x9o1EAE/review" target="_blank" class="rating-card" data-aos="fade-up"
                data-aos-delay="300">
                <img src="../../../assets/common/footer-icons/google-FooterRatings.png" alt="Google Reviews">
            </a>
            <a href="https://www.goodfirms.co/company/kalpita-technologies" target="_blank" class="rating-card"
                data-aos="fade-up" data-aos-delay="400">
                <img src="../../../assets/common/footer-icons/goodFirms-Ratings.svg" alt="GoodFirms">
            </a>
        </div>
    </div>
</div>

<!-- Job Listings Section -->
<section class="jobs-list-section">
    <div class="container">

        <!-- Header & Filter -->
        <div class="row align-items-center mb-5">
            <div class="col-lg-6">
                <h2 class="section-title">Open Positions</h2>
                <p class="section-subtitle">Find the role that fits your passion.</p>
            </div>
            <div class="col-lg-6">
                <div class="filter-wrapper">
                    <label for="locationSelect" class="filter-label">Filter by Location:</label>
                    <select id="locationSelect" class="custom-select" (change)="filterByLocation($event)">
                        <option value="">All Locations</option>
                        <option *ngFor="let location of locations" [value]="location">{{ location }}</option>
                    </select>
                </div>
            </div>
        </div>

        <!-- Job Cards -->
        <div class="job-cards-container">
            <div class="job-card" *ngFor="let item of filteredJobs; index as i" data-aos="fade-up">
                <div class="card-body">
                    <div class="job-header">
                        <div class="job-role">
                            <h3 class="job-title">{{ item.JobTitle }}</h3>
                            <span class="job-id">ID: {{ item.JobId }}</span>
                        </div>
                        <div class="job-location">
                            <i class="ri-map-pin-2-line"></i> {{ item.Location }}
                        </div>
                    </div>

                    <div class="job-details">
                        <div class="detail-item">
                            <i class="ri-briefcase-line"></i>
                            <span>{{ item.Experience }} Exp</span>
                        </div>
                        <div class="detail-item">
                            <i class="ri-calendar-line"></i>
                            <span>Posted: {{ item.JobPostedDate }}</span>
                        </div>
                    </div>

                    <div class="card-actions">
                        <button [routerLink]="['/careers/applyposition/', item.JobId]" class="btn-apply">
                            Apply Now <i class="ri-arrow-right-line"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="filteredJobs.length === 0" class="no-jobs-found text-center py-5">
                <h4>No positions found for this location.</h4>
                <p>Please check back later or select a different location.</p>
            </div>
        </div>

    </div>
</section>